import { FC } from "react";
import { LocalizationProvider, DateTimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TextField } from "@mui/material";
import dayjs from 'dayjs';
import 'dayjs/locale/uk';

dayjs.locale('uk');

interface IProps {
    isDisabled?: boolean; 
    title: string;
    value: number | null;
    handleDate: (date: Date | null) => void;
};

export const DateAndTimePicker: FC<IProps> = ({ handleDate, value, isDisabled, title }) => {
    const time = value ? new Date(value) : null;

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateTimePicker onChange={handleDate}
                value={time}
                renderInput={(props: any) =>
                    <TextField
                        variant="outlined"
                        fullWidth
                        color="primary"
                        {...props}
                        label={title}
                        disabled={isDisabled}
                    />
                }
            />
        </LocalizationProvider>
    )
};